import { _LogoLoneBase } from './logoLoneBase'

/** 单独的logo css变量实例  */
export class _LogoLoneDefault extends _LogoLoneBase {
  cssType: 'default' | 'larger' = 'default'
  protected initPC() {
    this['--logo-lone-width'] = '0.38rem'
    this['--logo-lone-height'] = '0.38rem'
    return this
  }
  protected initH5() {
    this['--logo-lone-width'] = '0.50rem'
    this['--logo-lone-height'] = '0.50rem'
    return this
  }
}
